export const applyHighlight = (searchValue: string, suggestion: string) => {
  const index = suggestion.indexOf(searchValue);
  if (index !== -1) {
    const start = suggestion.slice(0, index);
    const match = suggestion.slice(index, index + searchValue.length);
    const end = suggestion.slice(index + searchValue.length);

    return (
      <>
        {start}
        <span
          style={{
            color: "#0097A7",
            fontWeight: 500,
          }}
        >
          {match}
        </span>
        {end}
      </>
    );
  }

  return suggestion;
};
